export default __webpack_public_path__ + "static/media/case-pukka.d6e63e79.png";